import Checkbox from "@rio-cloud/rio-uikit/components/checkbox/Checkbox";
import { useMemo } from "react";

import '../styles.scss';

interface UptimeAssetRow {
	tagName: string;
	isTagSelected: boolean;
	isChecked: boolean;
	asset: {
		id: string;
		name?: string;
	};
	onAssetSelect: (assetId: string) => void;
}

const UptimeAssetRow = ({ asset, isTagSelected, isChecked, tagName, onAssetSelect }: UptimeAssetRow) => {
	const className = useMemo(() => `TreeLeaf form-group margin-bottom-0 ${tagName == "search-results-sidebar" ? "search" : ""}`, [tagName]);
	
	return (
		<div className={className} data-key={asset.id}>
			{(!isTagSelected) ? (
				<Checkbox className="TreeCheckbox" checked={isChecked} onChange={() => onAssetSelect(asset.id)} />
			) : null}
			<span className="TreeLabel">
				<span className="TreeLabelName !pr-0">
					<span className="rioglyph rioglyph-truck"></span>
					<span className="TreeLabelNameText">
						<span className="TreeLabelNameTextHeadline">{asset.name}</span>
					</span>
				</span>
			</span>
		</div>
	);
};

export default UptimeAssetRow;
